import {
  IBulkCollaboratorBatch,
  IBulkPayableBatch
} from "@wingspanhq/payments/dist/interfaces";
import { toWSDateString } from "@wingspanhq/fe-component-library";
import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { getUploadedFilename } from "./getUploadedFilename";
import { BulkResource } from "../types";
import { isFileUploaded } from "./bulkBatchUtils";

export const getBatchNames = (
  bulkBatch: IBulkPayableBatch | IBulkCollaboratorBatch
) => {
  const date = toWSDateString(bulkBatch.createdAt, "monthDayYear");
  const labelName = bulkBatch.labels?.[
    BATCH_LABELS_WS_KEYS.bulkBatchName
  ] as string;

  const fileName = isFileUploaded(bulkBatch)
    ? getUploadedFilename(
        bulkBatch,
        "bulkPayableBatchId" in bulkBatch
          ? BulkResource.Payable
          : BulkResource.Collaborator
      )
    : undefined;

  return {
    batchName: labelName || fileName || date || "--",
    batchFileName: labelName ? fileName : undefined
  };
};
